import { createContext } from 'react';
import { WorkflowStateService } from './types';

export const WorkflowStateMachineContext = createContext<{
    workflowService: WorkflowStateService;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
}>(null as any);
